import { getDate, getTime } from "../../utilities/date";
import ArrivalTime from "../shared/ArrivalTime";
import format from "date-fns/format";
import parse from "date-fns/parse";
import { extractHoursAndMinutes } from "../../utilities/date";

// Icons
import calendarIcon from "../../assets/icons/calendar.svg";
import timeIcon from "../../assets/icons/time.svg";
import fromIcon from "../../assets/icons/departure-time.svg";
import toIcon from "../../assets/icons/arrival-time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import fuelStopIcon from "../../assets/icons/fuel-stop-dark.svg";
import personIconDark from "../../assets/icons/person-dark.svg";
import luggageIcon from "../../assets/icons/luggage-dark.svg";

const TableHeaderLabel = ({ line1, line2 }) => (
    <span className="from-to-table__header-label">
        <span className="from-to-table__header-label-line">{line1}</span>
        <span className="from-to-table__header-label-line">{line2}</span>
    </span>
);

const FromToTable = ({ departureDateTime, arrivalDateTime, legData, duration, fuelStops }) => {
    return (
        <table className="from-to-table">
            <tbody>
                <tr>
                    <th className="from-to-table__header-col">
                        <span>
                            <img src={calendarIcon} alt="" />
                            <TableHeaderLabel line1="Dep" line2="Date" />
                        </span>
                    </th>
                    <th className="from-to-table__header-col">
                        <span>
                            <img src={timeIcon} alt="" />
                            <TableHeaderLabel line1="Dep" line2="Time" />
                        </span>
                    </th>
                    <th className="from-to-table__to-from-width">
                        <span>
                            <img src={fromIcon} alt="" />
                            From
                        </span>
                    </th>
                    <th>
                        <span>
                            <img src={durationIcon} alt="" />
                            Duration
                        </span>
                    </th>
                    <th className="from-to-table__to-from-width">
                        <span>
                            <img src={toIcon} alt="" />
                            To
                        </span>
                    </th>
                    <th className="from-to-table__header-col">
                        <span>
                            <img src={timeIcon} alt="" />
                            <TableHeaderLabel line1="Arr" line2="Time" />
                        </span>
                    </th>
                    <th>
                        <span>
                            <img src={personIconDark} alt="" />
                        </span>
                    </th>
                    <th>
                        <span>
                            <img src={luggageIcon} alt="" />
                        </span>
                    </th>
                </tr>

                {legData.map((leg, index) => {
                    let departureDate = getDate(departureDateTime[index]);
                    const parseDeparture = parse(departureDate, "yyyy-MM-dd", new Date());
                    const formattedDepartureDate = format(parseDeparture, "dd/MM/yy", { awareOfUnicodeTokens: true });

                    const departureTime = getTime(departureDateTime[index]);
                    const arrivalTime = getTime(arrivalDateTime[index]);
                    const arrivalDate = getDate(arrivalDateTime[index]);

                    return (
                        <tr key={index}>
                            <td>{formattedDepartureDate}</td>
                            <td>{departureTime}</td>
                            <td className="from-to-table__to-from-width">
                                <span>{leg.departureAirport?.longName || "-"}</span>
                            </td>
                            <td>
                                {fuelStops[index] > 0 && (
                                    <img className="from-to-table__fuel-stop-icon" src={fuelStopIcon} alt="" />
                                )}
                                {extractHoursAndMinutes(duration[index])} <br />
                                {fuelStops[index] === 1 && (
                                    <span className="from-to-table__fuel-stop-text">Fuel stop</span>
                                )}
                                {fuelStops[index] > 1 && (
                                    <span className="from-to-table__fuel-stop-text">{fuelStops[index]} Fuel stops</span>
                                )}
                            </td>
                            <td className="from-to-table__to-from-width">
                                <span>{leg.arrivalAirport?.longName || "-"}</span>
                            </td>
                            <td>
                                <ArrivalTime
                                    time={arrivalTime}
                                    departureDate={departureDate}
                                    arrivalDate={arrivalDate}
                                />
                            </td>
                            <td>{leg.passengers || "-"}</td>
                            <td>{leg.luggage !== undefined && leg.luggage !== null ? leg.luggage : "-"}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
export default FromToTable;
